import StoreProxy from './StoreProxy';

function getStorageKey(key: string) {
  return `BusStore.${key}`;
}

const store = new StoreProxy();
store.setStore({
  getItem: async (key) => {
    const rawData = localStorage.getItem(getStorageKey(key));
    if (rawData === null) {
      return null;
    }

    return JSON.parse(rawData);
  },
  removeItem: async (key) => localStorage.removeItem(getStorageKey(key)),
  setItem: async (key, value) => localStorage.setItem(getStorageKey(key), JSON.stringify(value)),
});

// Migrate previous IndexedDB Storage. This may be deleted in a few months when most users have been migrated (maybe > 2022-08)
(async () => {
  const db = window.indexedDB.open('bustore_prod');
  db.onsuccess = async () => {
    let legacyStore: IDBObjectStore;
    try {
      legacyStore = db.result.transaction(['keyvaluepairs']).objectStore('keyvaluepairs');
    }
    catch (e) {
      return;
    }

    async function migrateKey(key: string): Promise<boolean | null> {
      return new Promise<boolean | null>(async (res) => {
        if (await store.getItem(key)) {
          res(null);
          return;
        }

        const entry = legacyStore.get(key);
        entry.onsuccess = () => {
          if (entry.result !== undefined) {
            store.setItem(key, entry.result);
          }

          res(true);
        };
        entry.onerror = () => {
          res(false);
        };
      });
    }

    await Promise.all([
        'bookmarkStore',
        'SearchProvider.searchParams',
        'trackingUserId',
        'recentlyVisited',
        'SearchProvider.countryId',
      ]
      .map((key) => migrateKey(key))
    ).catch((e) => {
      // Display error but do nothing about it
      console.error(e);
    });

    indexedDB.deleteDatabase('bustore_prod');
  };
})().catch((e) => {
  // Display error but do nothing about it
  console.error(e);
});

export default store;
